const discussionStatus = {
  Accepted: 1,
  PartialAccepted: 2,
  Rejected: 3,
  Pending: 4,
  NA: 5
};

export default discussionStatus;
